module.exports = __webpack_public_path__ + "static/img/jersey2019-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jersey2019-2.jpg
// module id = AQVa
// module chunks = 0